//ハンバーガーメニュー
document.addEventListener("DOMContentLoaded", function () {
  var hamburger = document.querySelector(".hamburger");
  var menu = document.querySelector(".rms-header__menu");
  var body = document.querySelector("body");

  hamburger.addEventListener("click", function () {
    this.classList.toggle("active");
    menu.classList.toggle("active");
    body.classList.toggle("dark-mode"); // bodyに暗い背景のクラスをトグル
    body.classList.toggle("body-no-scroll"); // スクロールを無効化するクラスをトグル

    console.log("Body class toggled:", body.classList); // コンソールに現在のクラスリストを出力
  });
});

//header検索
document.addEventListener("DOMContentLoaded", function () {
  var searchToggle = document.querySelector(".search-toggle");
  var searchForm = document.querySelector(".search-form");

  searchToggle.onclick = function () {
    searchForm.style.display =
      searchForm.style.display === "block" ? "none" : "block";
    if (searchForm.style.display === "block") {
      searchForm.querySelector('input[type="search"]').focus();
    }
  };

  // フォームの外をクリックしたときにフォームを閉じる
  document.addEventListener("click", function (e) {
    if (!searchForm.contains(e.target) && !searchToggle.contains(e.target)) {
      searchForm.style.display = "none";
    }
  });
});

//giorgioについてページ（position:abusoluteの高さにrelativeを合わせる）
// ページの読み込みが完了したら関数を実行
window.onload = function () {
  adjustArtworkHeight();
  adjustParentHeight();
};

window.addEventListener("resize", adjustArtworkHeight);

// 親要素の高さを最初の子要素の高さに調整する関数
function adjustParentHeight() {
  var parent = document.querySelector(".giorgioSaulini__content");
  var child = document.querySelector(".giorgioSaulini__main");

  if (parent && child) {
    // 数値の加算を先に行い、その結果に 'px' を付加して設定
    parent.style.height = child.offsetHeight + 200 + "px";
  } else {
    console.error(
      "親要素または子要素が見つかりません。クラス名を確認してください。"
    );
  }
}

// 親要素 'about-the-artwork__content' の高さを子要素 'about-the-artwork__main' の高さに設定する関数
function adjustArtworkHeight() {
  var parent = document.querySelector(".about-the-artwork__content");
  var child = document.querySelector(".about-the-artwork__main");

  if (parent && child) {
    // 同様に数値の加算を先に行い、その結果に 'px' を付加して設定
    parent.style.height = child.offsetHeight + 200 + "px";
  } else {
    console.error(
      "親要素または子要素が見つかりません。クラス名を確認してください。"
    );
  }
}

// ドキュメントが完全に読み込まれた後に関数を実行
document.addEventListener("DOMContentLoaded", function () {
  adjustParentHeight();
});

// ウィンドウがリサイズされたときにも高さを再計算
window.addEventListener("resize", function () {
  adjustParentHeight();
});
